/* TODO: Replace this cookie implementation.
 *
 * One-off cookie implementation in plain javascript. Should really get
 * modularized or replaced with a 3rdparty implementation. We have used jquery
 * and a plugin called jquery.cookie for the other applications, but I don't
 * want to pull in jquery just for that...
 */

export function setCookie(options) {
  if (!options) {
    options = {};
  }

  if (!options.name || !options.value) {
    throw new Error("Must pass at least name and value");
  }

  var parts = [options.name + "=" + options.value];

  if (options.domain) {
    parts.push("domain=" + options.domain);
  }

  if (options.path) {
    parts.push("path=" + options.path);
  }

  if (options.expires) {
    var date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * options.expires);
    parts.push("expires=" + date.toGMTString());
  }

  document.cookie = parts.join(";");
}

export function getCookie(name) {
  var matches = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return matches ? matches[2] : null;
}
